import React, { useState, useEffect } from 'react';
import classes from './AdminProvince.module.css';
import { Spinner, Badge, Button, Modal, Form } from 'react-bootstrap';
// import Folder from '../../Images/folder-2.svg';
import axios from 'axios';
import { Link, useNavigate, useParams } from 'react-router-dom'
import Table from 'react-bootstrap/Table';
import { BASE_URL, TOKEN, BASE_URL1 } from "../../../Components/Styles/API/API";
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import Select from 'react-select';
import DeleteIcon from "../../../Assets/new-delete.svg"
import PencilIcon from "../../../Assets/pencil.svg"
import EyeIcon from "../../../Assets/new-eye.svg"
import FixedAssetNav from '../../Accoungting/HeaderNav/FixedAssetNav';
import HeaderNav from "../../FixedAssetReport/AdminNav/FixedAdminNav";
export default function AdminProvince() {
  const navigate = useNavigate();
  const [bearer, setBearer] = useState('');
  const [user, setUser] = useState('');
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [regionLoading, setRegionLoading] = useState(false);
  const [provinceLoading, setProvinceLoading] = useState(false);
  const [createRegionLoading, setCreateRegionLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [tableData44, setTableData44] = useState([]);
  const [tableData1, setTableData1] = useState([]);
  const [loading, setLoading] = useState(false);
  const [load, setLoad] = useState(false);
  const [loads, setLoads] = useState(false);
  const handleClose = () => setShow(false);
  const handleClose1 = () => setShow1(false);
  const handleShow = () => setShow(true);
  const handleShow1 = () => setShow1(true);
const [selectedContinent, setSelectedContinent] = useState('');
  const [eyeClicked, setEyeClicked] = useState(false);
  const [createProvLoading, setCreateProvLoading] = useState(false);
  const [trashClicked, setTrashClicked] = useState(false);
  const [eyeClicked1, setEyeClicked1] = useState(false);
  const [trashClicked1, setTrashClicked1] = useState(false);
  const [eyeClicked2, setEyeClicked2] = useState(false);
  const [trashClicked2, setTrashClicked2] = useState(false);
  const [entriesPerPage, setEntriesPerPage] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [entriesPerPage1, setEntriesPerPage1] = useState(100);
  const [currentPage1, setCurrentPage1] = useState(1);
  const [searchTerm1, setSearchTerm1] = useState("");
  const [entriesPerPage2, setEntriesPerPage2] = useState(100);
  const [currentPage2, setCurrentPage2] = useState(1);
  const [searchTerm2, setSearchTerm2] = useState("");
  const [description, setDescription] = useState('')
  const [description1, setDescription1] = useState('')
  const [accountantName, setAccountantName] = useState("");
  const [accountantName1, setAccountantName1] = useState("");
  const [accountantPhone, setAccountantPhone] = useState("");
  const [accountantPhone1, setAccountantPhone1] = useState("");
  const [accountantEmail, setAccountantEmail] = useState("");
  const [accountantEmail1, setAccountantEmail1] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedContinent1, setSelectedContinent1] = useState('');
  const [selectedRegion, setSelectedRegion] = useState('');
  const [tableData2, setTableData2] = useState([]);
  const [tableData12, setTableData12] = useState([]);
  const [tableData3, setTableData3] = useState([]);
  const [tableData33, setTableData33] = useState([]);
  const [admin, setAdmin] = useState('');
  const [roleLoading, setRoleLoading] = useState(false);
 
  const [selectedRegion1, setSelectedRegion1] = useState("");
  const [selectedProvince, setSelectedProvince] = useState("");

  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const value1 = await localStorage.getItem('tobi');
      const value2 = await localStorage.getItem('permissions');
      const value3 = await localStorage.getItem('admin');

      if (value !== null) {
        setBearer(value);
      }
      if (value1 !== null) {
        setUser(value1);
      }
      // if (value2 !== null) {
      //   setPermissions(value2);
      // }
      if (value3 !== null) {
        setAdmin(value3);
      }
    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };


const fetchContinents = async () => {
  setIsLoading(true);
  try {
    const response = await axios.get(`${BASE_URL1}/continents`, {
      headers: {
        'Authorization': `Bearer ${TOKEN}`,
        'Content-Type': 'application/json'
      },
    });

    const results = response.data?.data;

    const options = results.map((item) => ({
      label: item.description,
      value: item.id,
    }));
    
    setTableData(results);
    setTableData12(options);

  } catch (error) {
    let errorMessage = 'An error occurred. Please try again.';

    // Check if the API sent a response with a message
    if (error.response && error.response.data && error.response.data.message) {
      const msg = error.response.data.message;

      if (typeof msg === 'string') {
        // Case 1: Simple string
        errorMessage = msg;
      } else if (Array.isArray(msg)) {
        // Case 2: Array of strings
        errorMessage = msg.join('; ');
      } else if (typeof msg === 'object' && msg !== null) {
        // Case 3: Object (e.g., { region_id: ["The region id field is required."] })
        // Extract all values, flatten them into one array, and join them
        errorMessage = Object.values(msg).flat().join('; ');
      }
    } else if (error.message) {
       // Fallback to JS error message if no response data
       errorMessage = error.message;
    }

    // Display the actual message from the API
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: errorMessage,
      confirmButtonColor: '#d33',
      confirmButtonText: 'OK'
    });

    setTableData([]);
  } finally {
    setIsLoading(false);
  }
};
const fetchRegions = async () => {
  setRegionLoading(true);
  try {
    const response = await axios.get(`${BASE_URL1}/regions`, {
      headers: {
        'Authorization': `Bearer ${TOKEN}`,
        'Content-Type': 'application/json'
      },
    });

    // console.log(response);
    const reg = response.data?.data?.regions;
    setTableData1(reg);
    // console.log(results);

  } catch (error) {
    let errorMessage = 'An error occurred. Please try again.';

    // Check if the API sent a response with a message
    if (error.response && error.response.data && error.response.data.message) {
      const msg = error.response.data.message;

      if (typeof msg === 'string') {
        // Case 1: Simple string
        errorMessage = msg;
      } else if (Array.isArray(msg)) {
        // Case 2: Array of strings
        errorMessage = msg.join('; ');
      } else if (typeof msg === 'object' && msg !== null) {
        // Case 3: Object (e.g., { region_id: ["The region id field is required."] })
        // Extract all values, flatten them into one array, and join them
        errorMessage = Object.values(msg).flat().join('; ');
      }
    } else if (error.message) {
       // Fallback to JS error message if no response data
       errorMessage = error.message;
    }

    // Display the actual message from the API
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: errorMessage,
      confirmButtonColor: '#d33',
      confirmButtonText: 'OK'
    });

    setTableData1([]);
  } finally {
    setRegionLoading(false);
  }
};
 const fetchProvinces = async () => {
  setProvinceLoading(true);
  try {
    const response = await axios.get(`${BASE_URL1}/provinces`, {
      headers: {
        'Authorization': `Bearer ${TOKEN}`,
        'Content-Type': 'application/json'
      },
    });

    // console.log(response);
    const prov = response.data?.data.provinces;
    setTableData2(prov);
    // console.log(prov);

  } catch (error) {
    let errorMessage = 'An error occurred. Please try again.';

    // Check if the API sent a response with a message
    if (error.response && error.response.data && error.response.data.message) {
      const msg = error.response.data.message;

      if (typeof msg === 'string') {
        // Case 1: Simple string
        errorMessage = msg;
      } else if (Array.isArray(msg)) {
        // Case 2: Array of strings
        errorMessage = msg.join('; ');
      } else if (typeof msg === 'object' && msg !== null) {
        // Case 3: Object (e.g., { region_id: ["The region id field is required."] })
        // Extract all values, flatten them into one array, and join them
        errorMessage = Object.values(msg).flat().join('; ');
      }
    } else if (error.message) {
       // Fallback to JS error message if no response data
       errorMessage = error.message;
    }

    // Display the actual message from the API
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: errorMessage,
      confirmButtonColor: '#d33',
      confirmButtonText: 'OK'
    });

    setTableData2([]);
  } finally {
    setProvinceLoading(false);
  }
};
  
const fetchSubContinents = async (selectedContinent) => {
  setLoad(true);
  
  try {
    const response = await axios.get(`${BASE_URL1}/continents/getcontinentregions?continent_id=${selectedContinent}`, 
      { headers: {
          'Authorization': `Bearer ${TOKEN}`,
          'Content-Type': 'application/json'
      }, 
    });

    const subCont = response.data?.data;
    const options1 = subCont.map((item) => ({
      label: item.description,
      value: item.id,
    }));

    setTableData3(subCont);
    setTableData33(options1);
    console.log("Regions:", subCont);

  } catch (error) {
    let errorMessage = 'An error occurred. Please try again.';

    // Check if the API sent a response with a message
    if (error.response && error.response.data && error.response.data.message) {
      const msg = error.response.data.message;

      if (typeof msg === 'string') {
        // Case 1: Simple string
        errorMessage = msg;
      } else if (Array.isArray(msg)) {
        // Case 2: Array of strings
        errorMessage = msg.join('; ');
      } else if (typeof msg === 'object' && msg !== null) {
        // Case 3: Object (e.g., { region_id: ["The region id field is required."] })
        // Extract all values, flatten them into one array, and join them
        errorMessage = Object.values(msg).flat().join('; ');
      }
    } else if (error.message) {
       // Fallback to JS error message if no response data
       errorMessage = error.message;
    }

    // Display the actual message from the API
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: errorMessage,
      confirmButtonColor: '#d33',
      confirmButtonText: 'OK'
    });

    setTableData3([]);
  } finally {
    setLoad(false);
  }
};

const fetchSubContinents1 = async (selectedContinent1) => {
  setLoad(true);
  
  try {
    const response = await axios.get(`${BASE_URL}/continents/getcontinentregions?continent_id=${selectedContinent1}`, 
      { headers: {
          'Authorization': `Bearer ${TOKEN}`,
          'Content-Type': 'application/json'
      }, 
    });

    const subCont = response.data?.data;
    setTableData3(subCont);
   
  } catch (error) {
    let errorMessage = 'An error occurred. Please try again.';

    // Check if the API sent a response with a message
    if (error.response && error.response.data && error.response.data.message) {
      const msg = error.response.data.message;

      if (typeof msg === 'string') {
        // Case 1: Simple string
        errorMessage = msg;
      } else if (Array.isArray(msg)) {
        // Case 2: Array of strings
        errorMessage = msg.join('; ');
      } else if (typeof msg === 'object' && msg !== null) {
        // Case 3: Object (e.g., { region_id: ["The region id field is required."] })
        // Extract all values, flatten them into one array, and join them
        errorMessage = Object.values(msg).flat().join('; ');
      }
    } else if (error.message) {
       // Fallback to JS error message if no response data
       errorMessage = error.message;
    }

    // Display the actual message from the API
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: errorMessage,
      confirmButtonColor: '#d33',
      confirmButtonText: 'OK'
    });

    setTableData3([]);
  } finally {
    setLoad(false);
  }
};
  // console.log("tableData3:", tableData3)

  useEffect(() => {
    if (TOKEN && selectedContinent) {
      fetchSubContinents(selectedContinent);
    }
  }, [TOKEN, selectedContinent]);

  useEffect(() => {
    if (TOKEN && selectedContinent1) {
      fetchSubContinents1(selectedContinent1);
    }
  }, [TOKEN, selectedContinent1]);



  useEffect(() => {
    if (TOKEN) {
      fetchContinents();
      fetchRegions();
      fetchProvinces();

    }
  }, [TOKEN]);

  const handleContinent = (selectedOption) => {
    setSelectedContinent(selectedOption.value);
    setSelectedRegion('');
   
  };


  const handleRegion = (selectedOption) => {
    setSelectedRegion(selectedOption.value)
   
    
  }

const fetchSubRegion = async () => {
  setTableData2([]);
  setLoads(true);
  try {
    const response = await axios.get(`${BASE_URL1}/regions/getprovincesregion?region_id=${selectedRegion}`, {
      headers: {
        'Authorization': `Bearer ${TOKEN}`,
        'Content-Type': 'application/json'
      },
    });

    const subCont1 = response.data?.data;
    setTableData44(subCont1);
    console.log(response);

  } catch (error) {
    let errorMessage = 'An error occurred. Please try again.';

    // Check if the API sent a response with a message
    if (error.response && error.response.data && error.response.data.message) {
      const msg = error.response.data.message;

      if (typeof msg === 'string') {
        // Case 1: Simple string
        errorMessage = msg;
      } else if (Array.isArray(msg)) {
        // Case 2: Array of strings
        errorMessage = msg.join('; ');
      } else if (typeof msg === 'object' && msg !== null) {
        // Case 3: Object (e.g., { region_id: ["The region id field is required."] })
        // We extract all values, flatten them into one array, and join them
        errorMessage = Object.values(msg).flat().join('; ');
      }
    } else if (error.message) {
       // Fallback to JS error message if no response data
       errorMessage = error.message;
    }

    // Display the actual message from the API
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: errorMessage,
      confirmButtonColor: '#d33',
      confirmButtonText: 'OK'
    });

    setTableData44([]);
    
    // Optional: If you still want to redirect on 401 after showing the message
    if (error.response && error.response.status === 401) {
       // navigate('/login'); // Uncomment if you want to redirect after the error is shown
    }
  } finally {
    setLoads(false);
  }
};

  const createContinent = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${BASE_URL}/continents/create_continent`,
        {
          description: description,
         
        },
        { headers }
      );
      console.log(response)
      fetchContinents();
      handleClose();
   
      toast.success(response.data.message);
      console.log(response.data);

    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
            if (error.response && error.response.data && error.response.data.message) {
                if (typeof error.response.data.message === 'string') {
                    errorMessage = error.response.data.message;
                } else if (Array.isArray(error.response.data.message)) {
                    errorMessage = error.response.data.message.join('; ');
                } else if (typeof error.response.data.message === 'object') {
                    errorMessage = JSON.stringify(error.response.data.message);
                }
                toast.error(errorMessage);
                console.log(errorMessage);
            }
    } finally {
      setLoading(false);
    }
  };
  const createRegion = async () => {
    setCreateRegionLoading(true);
    try {
      const response = await axios.post(
        `${BASE_URL}/regions/create_region`,
        {
          description: description,
          continent_id: selectedContinent,
         
        },
        { headers }
      );
      console.log(response)
      fetchRegions();
      handleClose();
   
      toast.success(response.data.message);
      console.log(response.data);

    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
            if (error.response && error.response.data && error.response.data.message) {
                if (typeof error.response.data.message === 'string') {
                    errorMessage = error.response.data.message;
                } else if (Array.isArray(error.response.data.message)) {
                    errorMessage = error.response.data.message.join('; ');
                } else if (typeof error.response.data.message === 'object') {
                    errorMessage = JSON.stringify(error.response.data.message);
                }
                toast.error(errorMessage);
                console.log(errorMessage);
            }
    } finally {
      setCreateRegionLoading(false);
    }
  };
  const createProvince = async () => {
    setCreateProvLoading(true);
    try {
      const response = await axios.post(
        `${BASE_URL1}/provinces/create_province`,
        {
          description: description,
          continent_id: selectedContinent,
          region_id: selectedRegion,         
          as_at: selectedDate,         
        },
        { headers: {
          'Authorization': `Bearer ${TOKEN}`,
          'Content-Type': 'application/json'
      }, 
    }
      );
      console.log(response)
      fetchProvinces();
      handleClose();
   
      toast.success(response.data.message);
      console.log(response.data);

    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
            if (error.response && error.response.data && error.response.data.message) {
                if (typeof error.response.data.message === 'string') {
                    errorMessage = error.response.data.message;
                } else if (Array.isArray(error.response.data.message)) {
                    errorMessage = error.response.data.message.join('; ');
                } else if (typeof error.response.data.message === 'object') {
                    errorMessage = JSON.stringify(error.response.data.message);
                }
                toast.error(errorMessage);
                console.log(errorMessage);
            }
    } finally {
      setCreateProvLoading(false);
    }
  };


 
  function padZero(num) {
    return num < 10 ? `0${num}` : num;
  }

  const handleContinentChange = async (event) => {
    setSelectedContinent(event.target.value);
   setSelectedRegion("");
  }


  const handleRegionChange = (event) =>{
    setSelectedRegion(event.target.value)
  }

  const handleContinentChange1 = (event) =>{
    setSelectedContinent1(event.target.value)
  }
  const handleRegionChange1 = (event) =>{
    setSelectedRegion1(event.target.value)
  }


  const filteredData = tableData.filter(item => item.description.toLowerCase().includes(searchTerm.toLowerCase()));

  const totalPages = Math.ceil(filteredData.length / entriesPerPage);

  const handlePrevPage = () => {
    setCurrentPage(Math.max(currentPage - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage(Math.min(currentPage + 1, totalPages));
  };

  const totalEntries = filteredData.length;
  const startIndexx = (currentPage - 1) * entriesPerPage + 1;
  const endIndexx = Math.min(startIndexx + entriesPerPage - 1, totalEntries);
  const displayedData = filteredData.slice(startIndexx - 1, endIndexx);

  const filteredData1 = tableData1.filter(item => item.description.toLowerCase().includes(searchTerm1.toLowerCase()));

  const totalPages1 = Math.ceil(filteredData1.length / entriesPerPage1);

  const handlePrevPage1 = () => {
    setCurrentPage1(Math.max(currentPage1 - 1, 1));
  };

  const handleNextPage1 = () => {
    setCurrentPage1(Math.min(currentPage1 + 1, totalPages1));
  };

  const totalEntries1 = filteredData1.length;
  const startIndexx1 = (currentPage1 - 1) * entriesPerPage1 + 1;
  const endIndexx1 = Math.min(startIndexx1 + entriesPerPage1 - 1, totalEntries1);
  const displayedData1 = filteredData1.slice(startIndexx1 - 1, endIndexx1);
  
  const filteredData2 = tableData2.filter(item => item.description.toLowerCase().includes(searchTerm2.toLowerCase()));

  const totalPages2 = Math.ceil(filteredData2.length / entriesPerPage2);

  const handlePrevPage2 = () => {
    setCurrentPage2(Math.max(currentPage2 - 1, 1));
  };

  const handleNextPage2 = () => {
    setCurrentPage2(Math.min(currentPage2 + 1, totalPages2));
  };

  const totalEntries2 = filteredData2.length;
  const startIndexx2 = (currentPage2 - 1) * entriesPerPage2 + 1;
  const endIndexx2 = Math.min(startIndexx2 + entriesPerPage2 - 1, totalEntries2);
  const displayedData2 = filteredData2.slice(startIndexx2 - 1, endIndexx2);



  const handleEyeClick = (id) => {
    const foundContinent = tableData.find(item => item.id === id);
    setSelectedContinent(foundContinent);
    setDescription1(foundContinent?.description || '');
    setShow1(true);
    setEyeClicked(true);
  };

  const handleEyeClick1 = (id) => {
    // Find the selected grade from tableData using the id
    const foundRegion = tableData.find(item => item.id === id);
    setSelectedRegion(foundRegion);
    setDescription1(foundRegion?.description || '');
    setSelectedContinent1(foundRegion?.continent_id || '');
    setShow1(true);
    setEyeClicked(true);
  };

  const handleEyeClick2 = (id) => {
    const foundProvince= tableData2.find(item => item.id === id);
    setSelectedProvince(foundProvince);
    console.log(foundProvince);
    setDescription1(foundProvince?.description || '');
    setSelectedContinent1(foundProvince?.continent?.id || '');
    setSelectedRegion1(foundProvince?.region?.id || '');
    setShow1(true);
    setEyeClicked(true);
  };

  const handleTrashClick = async (id) => {
    const confirmResult = await Swal.fire({
      title: 'Are you sure?',
      text: 'You are about to delete this continent. This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    });

    if (confirmResult.isConfirmed) {
    try {
      const response = await axios.get(`${BASE_URL}/continents/delete_continent?id=${id}`, { headers });
      fetchContinents();
      toast.success(response.data.message);
      setTrashClicked(true);
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
            if (error.response && error.response.data && error.response.data.message) {
                if (typeof error.response.data.message === 'string') {
                    errorMessage = error.response.data.message;
                } else if (Array.isArray(error.response.data.message)) {
                    errorMessage = error.response.data.message.join('; ');
                } else if (typeof error.response.data.message === 'object') {
                    errorMessage = JSON.stringify(error.response.data.message);
                }
                toast.error(errorMessage);
            }
    }
  } else {
     
    Swal.fire({
      icon: 'info',
      title: 'Cancelled',
      text: 'The deletion was cancelled.',
    });
  }
  };

  const handleTrashClick1 = async (id) => {
    const confirmResult = await Swal.fire({
      title: 'Are you sure?',
      text: 'You are about to delete this region. This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    });

    if (confirmResult.isConfirmed) {
    try {
      const response = await axios.get(`${BASE_URL}/regions/delete_region?id=${id}`, { headers });
      fetchRegions();
      toast.success(response.data.message);
      setTrashClicked(true);
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
            if (error.response && error.response.data && error.response.data.message) {
                if (typeof error.response.data.message === 'string') {
                    errorMessage = error.response.data.message;
                } else if (Array.isArray(error.response.data.message)) {
                    errorMessage = error.response.data.message.join('; ');
                } else if (typeof error.response.data.message === 'object') {
                    errorMessage = JSON.stringify(error.response.data.message);
                }
                toast.error(errorMessage);
            }
    }
  } else {
     
    Swal.fire({
      icon: 'info',
      title: 'Cancelled',
      text: 'The deletion was cancelled.',
    });
  }
  };

  const handleTrashClick2 = async (id) => {
    const confirmResult = await Swal.fire({
      title: 'Are you sure?',
      text: 'You are about to delete this province. This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    });

    if (confirmResult.isConfirmed) {
    try {
      const response = await axios.get(`${BASE_URL1}/provinces/delete_province?id=${id}`, 
        { headers: {
          'Authorization': `Bearer ${TOKEN}`,
          'Content-Type': 'application/json'
      }, 
    }
      );
      fetchProvinces();
      toast.success(response.data.message);
      setTrashClicked(true);
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
            if (error.response && error.response.data && error.response.data.message) {
                if (typeof error.response.data.message === 'string') {
                    errorMessage = error.response.data.message;
                } else if (Array.isArray(error.response.data.message)) {
                    errorMessage = error.response.data.message.join('; ');
                } else if (typeof error.response.data.message === 'object') {
                    errorMessage = JSON.stringify(error.response.data.message);
                }
                toast.error(errorMessage);
            }
    }
  } else {
     
    Swal.fire({
      icon: 'info',
      title: 'Cancelled',
      text: 'The deletion was cancelled.',
    });
  }
  };

  
  const editContinent = async () => {
    setLoading(true);

    try {
      const response = await axios.post(
        `${BASE_URL}/continents/update_continent`,
        {
          description: description1,
          id: selectedContinent.id
          
        },
        { headers }
      );

      fetchContinents();

     toast.success(response.data.message);

      // console.log(response.data);
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
            if (error.response && error.response.data && error.response.data.message) {
                if (typeof error.response.data.message === 'string') {
                    errorMessage = error.response.data.message;
                } else if (Array.isArray(error.response.data.message)) {
                    errorMessage = error.response.data.message.join('; ');
                } else if (typeof error.response.data.message === 'object') {
                    errorMessage = JSON.stringify(error.response.data.message);
                }
                toast.error(errorMessage);
            }
    } finally {
      setLoading(false);
    }
  };
  const editRegion = async () => {
    setLoading(true);

    try {
      const response = await axios.post(
        `${BASE_URL}/regions/update_region`,
        {
          description: description1,
          continent_id: selectedContinent1,
          id: selectedRegion.id,
          accountant_name: accountantName1,
          accountant_email: accountantEmail1,
          accountant_phone_number: accountantPhone1
          
        },
        { headers }
      );

      fetchRegions();

     toast.success(response.data.message);

      // console.log(response.data);
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
            if (error.response && error.response.data && error.response.data.message) {
                if (typeof error.response.data.message === 'string') {
                    errorMessage = error.response.data.message;
                } else if (Array.isArray(error.response.data.message)) {
                    errorMessage = error.response.data.message.join('; ');
                } else if (typeof error.response.data.message === 'object') {
                    errorMessage = JSON.stringify(error.response.data.message);
                }
                toast.error(errorMessage);
            }
    } finally {
      setLoading(false);
    }
  };

  const editProvince = async () => {
    setLoading(true);

    try {
      const response = await axios.post(
        `${BASE_URL1}/provinces/update_province`,
        {
          continent_id: selectedContinent1,
          region_id: selectedRegion1,
          description: description1,
          id: selectedProvince.id,
          
        },
        { headers: {
          'Authorization': `Bearer ${TOKEN}`,
          'Content-Type': 'application/json'
      }, 
    }
      );

      fetchProvinces();
handleClose1();
     toast.success(response.data.message);

      // console.log(response.data);
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
            if (error.response && error.response.data && error.response.data.message) {
                if (typeof error.response.data.message === 'string') {
                    errorMessage = error.response.data.message;
                } else if (Array.isArray(error.response.data.message)) {
                    errorMessage = error.response.data.message.join('; ');
                } else if (typeof error.response.data.message === 'object') {
                    errorMessage = JSON.stringify(error.response.data.message);
                }
                toast.error(errorMessage);
            }
    } finally {
      setLoading(false);
    }
  };

  const getOrdinalSuffix = (number) => {
    const suffixes = ['th', 'st', 'nd', 'rd'];
    const v = number % 100;
    return v >= 11 && v <= 13 ? 'th' : suffixes[v % 10] || 'th';
  };
  
  const formatDate = (dateString) => {
    // Check if dateString is valid
    if (!dateString) return "Invalid date";
  
    // Assuming dateString is in "YYYY-MM-DD" format
    const [year, month, day] = dateString.split('-').map(Number); // Split by dash and convert to numbers
  
    // Create a Date object
    const date = new Date(year, month - 1, day); // month is zero-indexed for Date
  
    if (isNaN(date.getTime())) {
      return "Invalid date"; // Handle invalid dates
    }
  
    // Format date to "23rd October, 2024"
    const dayOfMonth = date.getDate();
    const monthName = date.toLocaleString('default', { month: 'long' });
    const yearNumber = date.getFullYear();
  
    return `${dayOfMonth}${getOrdinalSuffix(dayOfMonth)} ${monthName}, ${yearNumber}`;
  };

  const selectStyles = {
    container: (provided) => ({
      ...provided,
      // width: '90%',
      fontSize: 12,
    }),
    control: (provided) => ({
      ...provided,
      minHeight: "36px",
      fontSize: 12,
    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: 12,
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: 12,
      backgroundColor: state.isFocused ? "#f1f5f9" : "white",
      color: "#111827",
    }),
    menu: (provided) => ({
      ...provided,
      maxHeight: "300px",
      overflowY: "auto",
      fontSize: 12,
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };
  
  

return (
    <div>
      {/* Placeholder for Header if needed, using padding from your example */}
      <div style={{ padding: '0 2rem' }}>
        <HeaderNav />
      </div>

      {/* --- ADD PROVINCE MODAL --- */}
      <Modal show={show} onHide={handleClose} animation={false} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Province</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form style={{ marginTop: 20 }}>
            <Form.Group className="mb-3">
              <Form.Label>Continents</Form.Label>
              <Form.Select
                className="form-control"
                value={selectedContinent}
                onChange={handleContinentChange}
              >
                <option value="" disabled>Select Continent</option>
                {tableData.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.description}
                  </option>
                ))}
              </Form.Select>

              <div style={{ marginTop: 10 }} />
              <Form.Label>Region</Form.Label>
              <Form.Select
                className="form-control"
                value={selectedRegion}
                onChange={handleRegionChange}
              >
                <option value="" disabled>Select Region</option>
                {tableData3.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.description}
                  </option>
                ))}
              </Form.Select>

              <div style={{ marginTop: 10 }} />
              <Form.Label>Description</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />

              <div style={{ marginTop: 10 }} />
              <Form.Label>Date</Form.Label>
              <Form.Control
                type="date"
                value={selectedDate}
                onChange={(e) => setSelectedDate(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>
            Go back
          </Button>
          <Button
            style={{
              borderRadius: 5,
              background: "#092147",
              color: '#ffffff',
              border: 'none'
            }}
            onClick={createProvince}
            disabled={createProvLoading}
          >
            {createProvLoading ? (
              <>
                <Spinner size='sm' animation="border" role="status" />
                <span style={{ marginLeft: '5px' }}>Creating...</span>
              </>
            ) : (
              "Create Province"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* --- EDIT PROVINCE MODAL --- */}
      <Modal show={show1} onHide={handleClose1} animation={false} centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Province</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form style={{ marginTop: 20 }}>
            <Form.Group className="mb-3">
              <Form.Label>Continents</Form.Label>
              <Form.Select
                className="form-control"
                value={selectedContinent1}
                onChange={handleContinentChange1}
              >
                <option value="" disabled>Select Continent</option>
                {tableData.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.description}
                  </option>
                ))}
              </Form.Select>

              <div style={{ marginTop: 10 }} />
              <Form.Label>Region</Form.Label>
              <Form.Select
                className="form-control"
                value={selectedRegion1}
                onChange={handleRegionChange1}
              >
                <option value="" disabled>Select Region</option>
                {tableData3.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.description}
                  </option>
                ))}
              </Form.Select>

              <div style={{ marginTop: 10 }} />
              <Form.Label>Description</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Description"
                value={description1}
                onChange={(e) => setDescription1(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleClose1}>
            Go back
          </Button>
          <Button
            onClick={editProvince}
            style={{
              borderRadius: 5,
              background: "#092147",
              color: '#ffffff',
              border: 'none'
            }}
            disabled={loading}
          >
            {loading ? (
              <>
                <Spinner size='sm' />
                <span style={{ marginLeft: '5px' }}>Updating...</span>
              </>
            ) : (
              "Update Province"
            )}
          </Button>
        </Modal.Footer>
      </Modal>


      {/* --- MAIN CONTENT LAYOUT --- */}
      <div className={classes.topContainer}>
        <div style={{ marginTop: 24 }} />
        <h3 className={classes.topText}>Manage Province</h3>
        <p className={classes.prgText}>Add, View, Edit, and Delete Province.</p>

        {/* --- FILTER SECTION (Must preserve this functionality from first code) --- */}
        <div className="row mb-4 align-items-center" style={{ marginTop: '20px' }}>
  
  {/* Left side: Continent, Region, Process */}
  <div className="col-md-9 d-flex gap-3">

    <div 
    // className="flex-grow-1"
    >
      <Select
        onChange={(opt) => handleContinent(opt)}
        options={tableData12}
        placeholder="Select Continent"
        menuPortalTarget={document.body}
        styles={selectStyles}
      />
    </div>

    <div 
    // className="flex-grow-1"
    >
      <Select
        onChange={(opt) => handleRegion(opt)}
        options={tableData33}
        placeholder="Select Region"
        menuPortalTarget={document.body}
        isDisabled={!selectedContinent}
        styles={selectStyles}
      />
    </div>

    <div style={{ width: "180px" }}>
      <Button
        onClick={() => fetchSubRegion()}
        style={{
          backgroundColor: '#092147',
          color: "#ffffff",
          borderColor: '#e7e7e7',
          width: '100%'
        }}
      >
        {loads ? <Spinner size='sm' /> : "Process"}
      </Button>
    </div>
  </div>

  {/* Right side: Add Province */}
  <div className="col-md-3 d-flex justify-content-end">
    <Button
      style={{
        borderRadius: 5,
        background: "#092147",
        color: '#ffffff',
        border: 'none',
        width: 'fit-content'
      }}
      onClick={handleShow}
    >
      Add New Province
    </Button>
  </div>
  
</div>


        {/* --- ADD BUTTON SECTION --- */}
       

        <div style={{ marginTop: 24 }} />

        {/* --- TABLE CONTAINER --- */}
        <div className={classes.tableContainer}>
          <table className={classes.tableTable}>
            <thead className={classes.tableHeader}>
              <tr>
                <th>S/N</th>
                <th>Province</th>
                <th>Region</th>
                <th>Continent</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {(provinceLoading || loads) ? (
                <tr>
                  <td colSpan="5" className="text-center p-4">
                    <Spinner animation="border" size="sm" /> Fetching provinces...
                  </td>
                </tr>
              ) : (
                <>
                  {/* Logic for Main Display Data */}
                  {displayedData2.map((item, index) => (
                    <tr style={{ fontSize: "12px" }} key={index}>
                      <td>{index + 1}</td>
                      <td>{item.description}</td>
                      <td>{item.region?.description}</td>
                      <td>{item.continent?.description}</td>
                      <td style={{ whiteSpace: 'nowrap' }}>
                        <div onClick={() => handleEyeClick2(item.id)} className="btn btn-success-soft btn-sm mr-1" style={{ display: 'inline-block', cursor: 'pointer' }}>
                         <img src={EyeIcon} />
                        </div>
                        <div onClick={() => handleTrashClick2(item.id)} className="btn btn-danger-soft btn-sm" style={{ display: 'inline-block', cursor: 'pointer' }}>
                        <img src={DeleteIcon} />
                        </div>
                      </td>
                    </tr>
                  ))}

                  {/* Logic for SubRegion Filtered Data */}
                  {tableData44.map((item, index) => (
                    <tr style={{ fontSize: "12px" }} key={`sub-${index}`}>
                      <td>{index + 1}</td>
                      <td>{item.description}</td>
                      <td>{item.region?.description}</td>
                      <td>{item.continent?.description}</td>
                      <td style={{ whiteSpace: 'nowrap' }}>
                        <div onClick={() => handleEyeClick2(item.id)} className="btn btn-success-soft btn-sm mr-1" style={{ display: 'inline-block', cursor: 'pointer' }}>
                           <img src={EyeIcon} />
                        </div>
                        <div onClick={() => handleTrashClick2(item.id)} className="btn btn-danger-soft btn-sm" style={{ display: 'inline-block', cursor: 'pointer' }}>
                         <img src={DeleteIcon} />
                        </div>
                      </td>
                    </tr>
                  ))}

                  {displayedData2.length === 0 && tableData44.length === 0 && (
                    <tr style={{ fontSize: "12px" }}>
                      <td colSpan="5" className="text-center p-4" style={{ color: '#6c757d' }}>
                        No province available.
                      </td>
                    </tr>
                  )}
                </>
              )}
            </tbody>
          </table>
        </div>

        {/* --- PAGINATION --- */}
        <div className={classes.paginationStyle}>
          <div className={classes.footerSubOne}>
            <button
              className={classes.btnFirst}
              onClick={() => handlePrevPage2()}
              disabled={currentPage2 === 1}
              style={{ cursor: 'pointer', opacity: currentPage2 === 1 ? 0.5 : 1 }}
            >
              Previous
            </button>

            <span className={classes.ftOne}>
              {[...Array(totalPages2)].map((_, page) => {
                if (page < 5 || page === currentPage2 - 1 || page === totalPages2 - 1) {
                  return (
                    <button
                      key={page + 1}
                      className={`${classes.pageNumber} ${currentPage2 === page + 1 ? classes.active : ''}`}
                      onClick={() => setCurrentPage2(page + 1)}
                      style={{
                        margin: '0 5px',
                        fontWeight: currentPage2 === page + 1 ? 'bold' : 'normal',
                        backgroundColor: currentPage2 === page + 1 ? '#092147' : 'transparent',
                        color: currentPage2 === page + 1 ? '#fff' : '#000',
                        border: '1px solid #ddd',
                        padding: '5px 10px',
                        borderRadius: '4px',
                        cursor: 'pointer'
                      }}
                    >
                      {page + 1}
                    </button>
                  );
                }
                return null;
              })}
            </span>

            <button
              className={classes.btnSec}
              onClick={() => handleNextPage2()}
              disabled={currentPage2 === totalPages2}
              style={{ cursor: 'pointer', opacity: currentPage2 === totalPages2 ? 0.5 : 1 }}
            >
              Next
            </button>
          </div>
          <p className={classes.displayPag}>
            Displaying {startIndexx2}-{endIndexx2} of {totalEntries2} entries
          </p>
        </div>
      </div>
    </div>
  );
}